
import { Card, CardContent, CardHeader, Skeleton, Typography } from "@mui/material";
import IntlMessages from "util/IntlMessages";
import CardBox from "components/CardBox";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Chip from "@mui/material/Chip";
import { useState, useEffect } from "react";
import TitlebarImageList from "./TitlebarImageList";
import GetAppIcon from '@mui/icons-material/GetApp';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import { getUploadFileFullPathDownload } from "util/utilFunction";
import FileList from "./FileList";
import config from "config";


const ItemPreviewCard = ({item={}  , projectSettings={} ,   itemLangList=[] , selectedProject  , fileList=[] , visibility , previewRole , loading , itemMeans = "" , itemLang = null}) => {

    const [categoryName, setCategoryName] = useState("");



  const downloadFile = async (file, fileName="Dosya ") =>{
          fileName = fileName +" "+ config.docTypes[file.docType] + file.ext;
            getUploadFileFullPathDownload(file,fileName);
  };




    useEffect(() => {
        if(item){
            setCategoryName( selectedProject?.categoryList.length>0  ? selectedProject?.categoryList.find(x=>x.id===item.categoryId)?.name : "");
        }
    }, [selectedProject,item]);



  return <Card>
    <CardHeader title={item.title} />
    <CardContent>

          <div className="row">
          <CardBox
            styleName="col-md-6"
            heading={<IntlMessages id="item.information" />}
          >
            <List dense={true}>
            <Divider light />


            {selectedProject !== null  && <ListItem>
              <ListItemText
                  primary={<IntlMessages id="item.project" />}  primaryTypographyProps={{color:"secondary"}}
                  secondary={ selectedProject.name   }
                />
              </ListItem>}
              <Divider light />
     
              <ListItem>
                <ListItemText  color="teal"
                  primary={<IntlMessages id="item.title" />} primaryTypographyProps={{color:"secondary"}}
                  secondary={item.title}
                />
              </ListItem>
              <Divider light />

              <ListItem>
                <ListItemText  color="teal"
                  primary={<IntlMessages id="item.definition" />} primaryTypographyProps={{color:"secondary"}}
                  secondary={item.definition}
                />
              </ListItem>
              <Divider light />
              {visibility && <ListItem>
                <ListItemText
                  primary={<IntlMessages id="item.writer" />} primaryTypographyProps={{color:"secondary"}}
                  secondary={ Array.isArray(item.writers) ? item.writers.join(" , ") : item.writers}
                />
              </ListItem>}
              <Divider light />
              {/* <ListItem>
              <ListItemText
                primary={item.projectType===1 ?  <IntlMessages id="item.langEquivalent" /> :  <IntlMessages id="item.abstract" /> } primaryTypographyProps={{color:"secondary"}}
                secondary={item.abstract}
              />
            </ListItem>
            <Divider light /> */}


              <ListItem>
              <ListItemText
                primary={<IntlMessages id="item.lang" />} primaryTypographyProps={{color:"secondary"}}
                secondary={
                  item.lang 
                    ? Array.isArray(item.lang) 
                      ? item.lang.join(",") 
                      : item.lang.replace("#",",")
                    : ""
                }
              />
            </ListItem>
            <Divider  />

              <ListItem>
                <ListItemText
                  primary={<IntlMessages id="item.keyword" />} primaryTypographyProps={{color:"secondary"}}
                  secondary={ 
                    item.keyword
                      ? Array.isArray(item.keyword) 
                        ? item.keyword.map(keyWord=>
                            <Chip 
                              key={keyWord} 
                              disabled={!(visibility && previewRole !== "writer")} 
                              onClick={()=> visibility && previewRole !== "writer" ? history.push("/says/searchItem/"+keyWord) : null } 
                              color="primary" 
                              className="m-1" 
                              size="small" 
                              icon={<SpellcheckIcon />} 
                              label={keyWord} 
                            />
                          )
                        : item.keyword.split(",").map(keyWord=>
                            <Chip 
                              key={keyWord} 
                              disabled={!(visibility && previewRole !== "writer")}  
                              onClick={()=> visibility && previewRole !== "writer" ? history.push("/says/searchItem/"+keyWord) : null } 
                              color="primary" 
                              className="m-1" 
                              size="small" 
                              icon={<SpellcheckIcon />} 
                              label={keyWord} 
                            />
                          )
                      : ""
                  }
                />
              </ListItem>
        
              <Divider light />
          
              <ListItem>
            <ListItemText
                primary={<IntlMessages id="item.category" />} primaryTypographyProps={{color:"secondary"}}
                secondary={categoryName}
              />
            </ListItem>
            <Divider light />

            </List>

        

          </CardBox>
     
     
       </div>

       <div className="row my-3">
       <div className="col-md-6">
       <TitlebarImageList 
       title={"Görseller"}
       imageList={fileList.filter(x=>x.docType===3)}
       /> 
       </div>
       <div className="col-md-6">

       { 
   loading ? 
    <div>
       <Skeleton height={100} />
       <Skeleton height={100} />
       <Skeleton height={100} />
       <Skeleton height={100} />

    </div>
   :
   fileList.length>0 &&    
         <FileList fileList={fileList} 
                    itemTitle={item.title}
                    title={<IntlMessages id="fileUpload.list.title"/>}
                    handleDeleteState={true}
                    handleDeleteIcon={<GetAppIcon/>}
                    handleDelete={( file, itemTitle)=>downloadFile(file, itemTitle)} 
                    styleName="col-md-12 alert-warning mb-2"
                    dense={true}
                    />
   }       </div>
       </div>
      
    
   {projectSettings.privateColumnStatus === 1 && <div className="row">
      <CardBox
        styleName="col-md-12 col-12"
        heading={ projectSettings.privateColumnName}
      >
    
          <span
            className="card-text"
            dangerouslySetInnerHTML={{ __html: item.abstract }}
            
          />
            
          
       
      </CardBox>
      </div>}
      {
        item.projectType === 2 && itemLangList.map(itemLang=>      <CardBox
          styleName="col-md-12 col-12" key={"sas"+itemLang.id}
          heading={<IntlMessages id="item.abstract" />}
        >
      {itemLang.lang}
            <span
              className="card-text"
              dangerouslySetInnerHTML={{ __html: itemLang.langAbstract }}
              
            />
              
            
         
        </CardBox>)
      }
          <div className="row">
          <CardBox
            styleName="col-md-12 col-12"
            heading={item.projectType===1 ?  (item.title + ( item.definition !== "" ? "   ("+item.definition+")" :"")): item.isSuggest ? "Gerekçe" : <IntlMessages id="item.itemText" /> } 
          >
        
      
              <span
                className="card-text"
                dangerouslySetInnerHTML={{ __html: item.itemText }} 
                
              />
              
             
                
              
           
          </CardBox>
          </div>

     { item.projectType ===1 && <div className="row">
      <CardBox
        styleName="col-md-12 col-12"
        heading={<IntlMessages id="item.langItemText" />}
      >
    <div>{itemLang !== null && item.projectType ===1 ?
                    itemLang.map((item,index)=><ItemLangCard index={index} item={item} />)

    : itemLangList.length>0 && item.projectType ===1 ? 
   itemLangList.map((item,index)=><ItemLangCard index={index} item={item} />)
    :
          null } </div>
            
          
       
      </CardBox>
      </div>}

   {(item.projectType ===2)  ?
                    itemLangList.map((item,index)=>  
      <CardBox
        styleName="col-md-12 col-12"
        heading={<IntlMessages id="item.langItemText" /> }
      >
        {item.lang}
    <div>
                    <span
                    className="card-text"
                    dangerouslySetInnerHTML={{ __html: item.langItemText }}
                    
                  /> 
   </div>
            
          
       
      </CardBox>
     ) : " "}

   
      <div className="row">
      <CardBox
        styleName="col-md-12 col-12"
        heading={<IntlMessages id="item.sourceText" />}
      >
    
          <span
            className="card-text"
            dangerouslySetInnerHTML={{ __html: item.sourceText }}
            
          />
            
          
       
      </CardBox>
      </div>
   
    </CardContent>
  </Card>;
};

export default ItemPreviewCard;